<script>
import ModelShow from "../models/show";
import Row from "@/components/models/show/custom-row";

export default {
  extends: ModelShow,
  page: {
    title: "Detail JALA Trade User",
  },
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t("jala_investor_users.singular"));
      },
    },
    resourceRoute: { default: "jala_investor_users" },
    modelVariable: { default: "jala_harvest" },
    columns: {
      type: Object,
      default() {
        return {
          [this.modelVariable || "model"]: [
            {
              key: "key",
              label: this.$t("models.key"),
              component: Row,
            },
          ],
        };
      },
    },
    denyEdit:  {default: true},
    denyDelete:  {default: true}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t("jala_investor_users.plural")),
    };
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t("jala_investor_users.plural")),
          href: "/jala_investor_users",
        },
        {
          text:
            this.model && this.model.id
              ? this.model["id"]
              : this.$route.params.key,
          href: `/jala_investor_users/${this.$route.params.key}`,
          active: true,
        },
      ];
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model)
        ? []
        : [
            {
              key: this.lodash.startCase(this.$t("jala_users.email")),
              value: this.model.user?.email || "",
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(this.$t(`jala_users.avatar`)),
              item: this.model.user.avatar,
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                template: `<div class="col-md-6">
                          <b-avatar
                            button
                            variant="secondary"
                            :src="jalaStorageLink(item)"
                            size="72px"
                            disabled="true"
                            class="me-3"
                        ></b-avatar>
                        </div>`,
              },
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(this.$t("jala_users.name")),
              value: this.model.user?.name || "",
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(this.$t("jala_users.phone")),
              value: this.model.user?.phone || "",
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(this.$t("jala_users.role")),
              value: this.lodash.startCase(this.model.jala_trade_role || ""),
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
          ];
    },
  },
  methods: {
    delete() {
      return this.$axios.delete(`/jala/harvests/${this.$route.params.key}`);
    },
    fetchModel() {
      this.loading = true;
      return this.$axios
        .get(`/jala/investor_users/${this.$route.params.key}`, {
          params: { with: "cycle.pond.farm,user" },
        })
        .then((response) => {
          const {
            data: { data },
          } = response;
          
          this.model = {
            ...data,
            jala_trade_role: data.role_id === 6 ? 'admin' : ((data.state || {}).jala_trade_role || 'admin'),
          };
          return response;
        })
        .catch((error) => this.failedAlert(error))
        .finally(() => (this.loading = false));
    },
  },
};
</script>
